export default __webpack_public_path__ + "static/media/CelularComVideo.7750b2db.mp4";